import React, { createContext, useContext, useState } from 'react';

const BrandingContext = createContext();

export const useBrandingContext = () => useContext(BrandingContext);

export const BrandingProvider = ({
  children,
  initialData = {
    sideBar_BackgroundColor: '#1a1f36',
    sideBar_Active_BackgroundColor: '#e4e8f0',
    sideBar_TextColor: '#f5f6fa',
    sideBar_Active_TextColor: '#1a1f36',
    sideBar_Hover_BackgroundColor: '#3e4c66',
    sideBar_Hover_TextColor: '#ffffff',
    page_ButtonColor: '#0957d0',
  },
}) => {
  const [brandingData, setBrandingData] = useState(initialData);

  const contextValue = {
    brandingData,
    setBrandingData,
  };

  return (
    <BrandingContext.Provider value={contextValue}>
      {children}
    </BrandingContext.Provider>
  );
};
